import { Grid, Badge, Typography, Toolbar, MenuItem, Menu, IconButton, Divider, Button, AppBar } from "@mui/material";
import { ReactComponent as ProfileIcon } from "../Common/Icons/nav_profile.svg";
import { ReactComponent as ProfileSelectedIcon } from "../Common/Icons/nav_profile_selected.svg";
import NotificationsIcon from "@mui/icons-material/Notifications";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../actions/auth_actions";
import { getBillingConsole } from "../../actions/portal_actions"
import * as ROUTES from "../../constants/routes";
import { Can } from "../Abilities/";
import { ContractSwitcherMenu } from "./ContractSwitcherMenu";
import config from "../../config";

const Navigation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const version =
    process.env.REACT_APP_STAGE +
    "@" +
    process.env.REACT_APP_VERSION +
    (process.env.REACT_APP_BUILD
      ? "." + parseInt(process.env.REACT_APP_BUILD, 10)
      : "");

  const { portaldetails = {}, portalusers = {}, vacancies = {}, auth = {} } = useSelector(state => state);

  const doLogout = () => {
    dispatch(logout(null, navigate));
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getVariant = (route) => {
    if (location.pathname.indexOf(route) === 0) {
      return "primary";
    } else {
      return "default";
    }
  };

  const { orgdetails = {}, user = {}, unverifiedRolesLength = 0, unverifiedDepartmentsLength = 0, unverifiedLineManagersLength = 0 } = portaldetails;
  const { snackBarText } = vacancies;
  const totalNotifcaitons = unverifiedRolesLength + unverifiedDepartmentsLength + unverifiedLineManagersLength;
  const open = Boolean(anchorEl);
  const isInternalMobility = user.role === "hr-manager" || user.role === "line-manager";
  const { isCustomer = false } = portalusers;
  const disabledNav = !!snackBarText; //for preventing nav while search is going

  return (
    <div style={{ flexGrow: 1 }}>
        <AppBar
          color="default"
          sx={{ backgroundColor: "white"}}
          elevation={10}
        >
          <Toolbar sx={{
            px: { xs: 0.625, sm: 0.625, md: 2, lg: 2 },
            '@media (min-width: 1250px)': {
              width: 1250,
              mx: "auto",
            }
          }}>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{width:"100%"}}
            >
              <Grid item>
                <Link to="/">
                  <Button>
                    <img
                      //src={"/images/logo_gray.png"}
                      src={
                        config.STORAGE_CLOUDFRONT_URL +
                        (orgdetails.appNavLogoURL
                          ? orgdetails.appNavLogoURL + "?"
                          : "/logos/default_portal_nav_logo.png?") +
                        Date.now()
                      }
                    style={{
                      maxWidth: 130,
                      maxHeight: 30,
                      marginTop: 2,
                      marginRight: 20,
                      flexGrow: 1,
                    }}
                      alt={version}
                      title={version}
                    />
                  </Button>
                </Link>
              </Grid>
              <Grid item size="grow">
                <Grid
                  container
                  direction="row"
                justifyContent="space-evenly"
                  alignItems="center"
                  style={{justifyContent:"space-evenly"}}
                >
                  <Can I="visit" this={ROUTES.VACANCIES}>
                    <Grid item>
                      <Button
                        classes={{
                        label: { fontWeight: "normal", color: "inherit" },
                      }}
                      color={getVariant(ROUTES.VACANCIES)}
                        sx={{ textTransform: 'capitalize' }}
                        component={Link}
                        to={ROUTES.VACANCIES}
                        disabled={disabledNav}
                      >
                        Vacancies & Projects
                      </Button>
                    </Grid>
                  </Can>
                  <Can I="visit" this={ROUTES.EMPLOYEES}>
                    <Grid item>
                      <Button
                        classes={{
                        label: { fontWeight: "normal", color: "inherit" },
                      }}
                      component={Link}
                      color={getVariant(ROUTES.EMPLOYEES)}
                        sx={{ textTransform: 'capitalize' }}
                        to={ROUTES.EMPLOYEES}
                        disabled={disabledNav}
                      >
                        Employees
                      </Button>
                    </Grid>
                  </Can>
                  <Can I="visit" this={ROUTES.CANDIDATES}>
                    <Grid item>                    
                      <Button
                        classes={{
                        label: { fontWeight: "normal", color: "inherit" },
                      }}
                      component={Link}
                      color={getVariant(ROUTES.CANDIDATES)}
                        sx={{ textTransform: 'capitalize' }}
                        to={ROUTES.CANDIDATES}
                        disabled={disabledNav}
                      >
                        Candidates
                      </Button>
                    </Grid>
                  </Can>
                  <Can I="visit" this={ROUTES.DASHBOARDS}>
                    <Grid item>
                      <Button
                        classes={{
                        label: { fontWeight: "normal", color: "inherit" },
                      }}
                      component={Link}
                      color={getVariant(ROUTES.DASHBOARDS)}
                        sx={{ textTransform: 'capitalize' }}
                        to={ROUTES.DASHBOARDS}
                        disabled={disabledNav}
                      >
                        Engagement
                      </Button>
                    </Grid>
                  </Can>
                  <Can I="visit" this={ROUTES.CASELOADS}>
                    <Grid item>
                      <Button
                        classes={{
                        label: { fontWeight: "normal", color: "inherit" },
                      }}
                      component={Link}
                      color={getVariant(ROUTES.CASELOADS)}
                        sx={{ textTransform: 'capitalize' }}
                        to={ROUTES.CASELOADS}
                        disabled={disabledNav}
                      >
                        Activity
                      </Button>
                    </Grid>
                  </Can>                  
                  <Can I="visit" this={ROUTES.WORKFORCE_PLANNING}>
                    <Grid item>
                      <Button
                        classes={{
                        label: { fontWeight: "normal", color: "inherit" },
                      }}
                      component={Link}
                      color={getVariant(ROUTES.WORKFORCE_PLANNING)}
                        sx={{ textTransform: 'capitalize' }}
                        to={ROUTES.WORKFORCE_PLANNING}
                        disabled={disabledNav}
                      >
                        Workforce Intelligence
                      </Button> 
                    </Grid>
                  </Can>
                  <Can I="visit" this={ROUTES.SUPER_ADMIN_FEEDBACK}>
                    <Grid item>
                      <Button
                        classes={{
                        label: { fontWeight: "normal", color: "inherit" },
                      }}
                      component={Link}
                      color={getVariant(ROUTES.SUPER_ADMIN_FEEDBACK)}
                        sx={{ textTransform: 'capitalize' }}
                        to={ROUTES.SUPER_ADMIN_FEEDBACK}
                        disabled={disabledNav}
                      >
                        Feedback
                      </Button>
                    </Grid>
                  </Can>
                  <Can I="visit" this={ROUTES.SUPER_ADMIN_FEEDBACK_SKILLS}>
                    <Grid item>
                      <Button
                        classes={{
                        label: { fontWeight: "normal", color: "inherit" },
                      }}
                      component={Link}
                      color={getVariant(ROUTES.SUPER_ADMIN_FEEDBACK_SKILLS)}
                        sx={{ textTransform: 'capitalize' }}
                        to={ROUTES.SUPER_ADMIN_FEEDBACK_SKILLS}
                        disabled={disabledNav}
                      >
                        Skills Assessment Feedback
                      </Button>
                    </Grid>
                  </Can>
                </Grid>
              </Grid>
              <Grid item sx={{ display: "flex", alignItems: "center" }}>
                <Can I="see" this={"CONTRACT_SWITCHER"}>
                  <div style={{ paddingRight: "1em" }}>
                    <ContractSwitcherMenu />
                  </div>
                </Can>
                <Typography
                  variant="body2"
                  color="inherit"
                sx={{ textDecoration: "none", color: "black", display: "flex", alignItems: "center", cursor: "pointer" }}
                onClick={handleMenu}
                >
                <Badge badgeContent={totalNotifcaitons} sx={{ "& .MuiBadge-badge": { color: "#B4B8BF", backgroundColor: "red" } }} style={{ margin: 10, color: "#B4B8BF" }} overlap="rectangular">
                    <NotificationsIcon/>
                  </Badge>
                {auth.currentAuthUser &&
                  auth.currentAuthUser.attributes &&
                  (auth.currentAuthUser.attributes.given_name || auth.currentAuthUser.attributes.email)}
                </Typography>
                <div>
                  <IconButton
                    aria-owns={open ? "menu-appbar" : undefined}
                    aria-haspopup="true"
                  onClick={handleMenu}
                  >
                  {location.pathname.indexOf(ROUTES.PROFILE) === 0 || location.pathname.indexOf(ROUTES.ADMIN) === 0 ? (
                      <ProfileSelectedIcon />
                    ) : (
                      <ProfileIcon />
                    )}
                  </IconButton>
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={open}
                  onClose={handleClose}
                  >
                  {auth.currentAuthUser && (
                      <MenuItem disabled>
                      {auth.currentAuthUser.attributes.email}
                      </MenuItem>
                    )}

                    <Divider light />
                    <Can I="visit" this={ROUTES.PROFILE}>
                      <MenuItem
                      onClick={handleClose}
                        component={Link}
                        to={ROUTES.PROFILE}
                        disabled={disabledNav}
                      >
                        Account
                      </MenuItem>
                    </Can>
                    <Can I="visit" this={ROUTES.FAQ}>
                      <MenuItem
                      onClick={handleClose}
                        component={Link}
                        to={ROUTES.FAQ}
                        disabled={disabledNav}
                      >
                        FAQ's
                      </MenuItem>
                    </Can>
                    {isCustomer && (
                      <MenuItem
                        onClick={async () => {
                        const portal = await dispatch(getBillingConsole());
                          if(portal && portal.url){
                            window.location.replace(portal.url)
                          }
                        }}
                        disabled={disabledNav}
                      >
                        Manage Billing
                      </MenuItem>
                    )}
                    <Can I="visit" this={ROUTES.ORGANISATION}>
                      <MenuItem
                        style={{display:"flex", justifyContent:"space-between"}}
                      onClick={handleClose}
                        component={Link}
                        to={ROUTES.ORGANISATION}
                        disabled={disabledNav}
                      >
                        Admin
                      <Badge badgeContent={totalNotifcaitons} sx={{ "& .MuiBadge-badge": { color: "#B4B8BF", backgroundColor: "red" } }} style={{ margin: 10 }} />
                      </MenuItem>
                    </Can>

                    <Divider light />
                  <MenuItem onClick={doLogout}>Logout</MenuItem>
                  </Menu>
                </div>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </div>
    );
};

export default Navigation;
